/**
 * API client for persisted user notifications.
 *
 * @module notificationsApi
 */

import { apiGet, apiPatch } from '@/lib/apiUtils';

export const NOTIFICATION_HUMAN_REVIEW_COMPLETED = 'HUMAN_REVIEW_COMPLETED';

export interface NotificationItem {
  readonly id: string;
  readonly type: string;
  readonly payload?: Record<string, unknown> | null;
  readonly read: boolean;
  readonly createdAt: string;
}

export interface MarkReadResponse {
  readonly markedCount: number;
}

export async function getUnreadNotifications(): Promise<NotificationItem[]> {
  const result = await apiGet<NotificationItem[]>('/notifications', {
    errorMessage: 'Failed to load notifications',
    context: 'getUnreadNotifications',
    suppressErrorToast: true,
  });
  return result ?? [];
}

/** Mark unread notifications read, optionally filtered by type. */
export async function markNotificationsRead(type?: string): Promise<MarkReadResponse | null> {
  return apiPatch<MarkReadResponse>(
    '/notifications/mark-read',
    type ? { type } : {},
    {
      errorMessage: 'Failed to update notifications',
      context: 'markNotificationsRead',
      suppressErrorToast: true,
    },
  );
}
